// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__uiawX","boxTitle":"Qualiphy_boxTitle__2rBIj","box":"Qualiphy_box__1khgl","toggleWrap":"Qualiphy_toggleWrap__1MHGg"};